/* eslint-disable react-hooks/exhaustive-deps */
import useSWR, { SWRConfiguration } from 'swr'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { learningApi } from '../../../services/api'
import { usePagination } from '../../../hooks/use-pagination'
import { useLocalStorage } from 'react-use'
import { IBookQuestion } from '../components/QuestionBookComponent/types'

export function useGetQuestionByBook(bookId: string) {
  const [order, setOrder] = useState<'new' | 'old'>('new')
  const [itemsPerPage, setItemsPerPage] = useLocalStorage(
    'use-get-question-by-book--items-per-page',
    1
  )
  const [totalPages, setTotalPages] = useState(1)
  const pagination = usePagination({ total: totalPages })

  const token = localStorage.getItem('token')

  const mostRecent = order === 'new'

  const key = token
    ? `/question/books/${bookId}/items?page=${pagination.active}&mostRecent=${mostRecent}&limit=${itemsPerPage}`
    : null

  const swr = useSWR<{ docs: IBookQuestion[]; total: number }>(key, fetcher(token), configuration)

  useEffect(() => {
    if (swr.isLoading) return

    setTotalPages(Math.ceil(swr.data.total / itemsPerPage || 1))
  }, [swr.data, swr.isLoading, itemsPerPage])

  const setItemsPerPageProxy = (value: number) => {
    pagination.first()
    setItemsPerPage(value)
  }

  const setOrderProxy = (value: 'new' | 'old') => {
    pagination.first()
    setOrder(value)
  }

  return {
    swr,
    pagination,
    params: {
      itemsPerPage,
      setItemsPerPage: setItemsPerPageProxy,
      order,
      setOrder: setOrderProxy,
    },
  }
}

const fetcher = (token: string) => (url: string) =>
  learningApi
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: {
    docs: [],
    total: 0,
  },
  onError() {
    toast.error('Não foi possível carregar suas questões. Tente novamente mais tarde.')
  },
  errorRetryCount: 0,
}
